import CONSTANTS from 'src/store/constants';

export const ROUTES = {
  HOME: '/',

  // ONBOARDING
  ONBOARDING_LANDING: '/onboarding_landing',
  ONBOARDING: '/onboarding',
  ONBOARDING_VIEW: '/onboarding/:onbId/view',
  GENERATE_MODELS: '/onboarding/generate-models',
  NEW_ONBOARDING: '/onboarding/new-onboarding',
  RE_ONBOARDING: '/onboarding/re-onboarding',
  NEW_EXPRESS_ONBOARDING: '/onboarding/data-enrichment-plus-modeling-tool',
  NEW_DATA_ENRICHMENT: '/onboarding/data-enrichment-tool/:enrichmentType',

  DATA_ENRICHMENT_DOWNLOAD: '/onboarding/data-enrichment-download',

  // SEGMENTS
  SEGMENTS: '/datasets',
  VIEW_SEGMENTS: '/:entity/:entityId/view',
  COMPARE_SEGMENTS: '/segments/compare',
  SEGMENTS_PRED_MODEL: '/segments/:segmentId/pred-model',
  SEGMENTS_FACETS_VIEW: '/segments/:segmentId/facets-view',
  SEGMENTS_OCEAN_VIEW: '/segments/:segmentId/ocean-view',

  // CLUSTERS
  CLUSTERS: '/segments/:segmentId/clusters',

  // MODELS
  MODELS: '/models', // List page
  MODEL_LIFT_CHARTS: '/models/:modelClass/:modelId/lift-charts',
  MODEL_INPUT_DISTRIBUTIONS: '/models/:modelClass/:modelId/input-distributions',
  MODEL_VALIDATION_ANALYTICS: '/models/:modelClass/:modelId/validation-analytics',
  MODEL_ROI_CALCULATOR: '/models/:modelClass/:modelId/roi-calculator',
  MODEL_ROI_CALCULATOR_CMP: '/models/:modelClass/compare/roi-calculator',
  MODEL_FAIRNESS: '/models/:modelClass/:modelId/fairness',
  MODELS_COMPARE: '/models/:modelClass/compare',

  // REAL TIME API
  REAL_TIME_API: '/rt',
  REAL_TIME_API_DEMO: '/rt/:configId',
  REAL_TIME_API_DOCUMENTATION: '/rt/documentation',
  REAL_TIME_API_DOCUMENTATION_CONFIG: '/rt/documentation/:configId',
  REAL_TIME_API_USAGE: '/rt/usage',
  REAL_TIME_API_USAGE_CONFIG: '/rt/usage/:configId',

  // COPY PERSONALIZTION
  COPY_PX: '/copypx',

  // Regulatory
  REGULATORY: '/regulatory',

  // USERS
  USERS: '/users',
  USERS_ADD: '/users/add',
  USERS_VIEW: '/users/:userId',

  // SFTP for the selected client
  SFTP: '/sftp',

  // CLIENTS
  CLIENTS: '/clients',
  CLIENTS_ADD: '/clients/add',
  CLIENTS_EDIT: '/clients/:clientId',
  CLIENTS_EDIT_SUBS: '/clients/:clientId/subscribers',

  // AUTH
  TOKEN: '/token',
  LOGIN: '/login',
  PASSWORD_CHALLENGE: '/password-challenge',
  FORGOT_PASSWORD: '/forgot-password',
  CHANGE_PASSWORD: '/change-password',
};

export const RBAC = {
  PAGES: {
    CLIENTS: CONSTANTS.ROLES.slice(0, 4),
    SFTP: [
      CONSTANTS.ROLE.SUPER_ADMIN,
      CONSTANTS.ROLE.ACTUARY,
      CONSTANTS.ROLE.CLIENT_SERVICES_ADMIN,
      CONSTANTS.ROLE.CLIENT_SERVICES,
    ],
    USERS: [
      CONSTANTS.ROLE.VIEWER,
      CONSTANTS.ROLE.ADMIN,
      CONSTANTS.ROLE.SUPER_ADMIN,
      CONSTANTS.ROLE.CLIENT_SERVICES_ADMIN,
      CONSTANTS.ROLE.CLIENT_SERVICES,
    ],
    ONBOARDING: [CONSTANTS.ROLE.VIEWER, CONSTANTS.ROLE.ADMIN, CONSTANTS.ROLE.SUPER_ADMIN],
    DATASETS: [CONSTANTS.ROLE.VIEWER, CONSTANTS.ROLE.ADMIN, CONSTANTS.ROLE.SUPER_ADMIN],
    MODELS: [CONSTANTS.ROLE.VIEWER, CONSTANTS.ROLE.ADMIN, CONSTANTS.ROLE.SUPER_ADMIN],
    REAL_TIME_API: [CONSTANTS.ROLE.VIEWER, CONSTANTS.ROLE.ADMIN, CONSTANTS.ROLE.SUPER_ADMIN],
    COPY_PX: [CONSTANTS.ROLE.SUPER_ADMIN, CONSTANTS.ROLE.VIEWER, CONSTANTS.ROLE.ADMIN],
    REGULATORY: [CONSTANTS.ROLE.SUPER_ADMIN, CONSTANTS.ROLE.ACTUARY],
  },

  CAN_UPDATE_USER_SITE_ROLE: [CONSTANTS.ROLE.SUPER_ADMIN, CONSTANTS.ROLE.ACTUARY, CONSTANTS.ROLE.CLIENT_SERVICES_ADMIN],
  CAN_EDIT_SFTP: CONSTANTS.ROLES.filter((role) => role !== CONSTANTS.ROLE.VIEWER),
};
